import { Base } from "../Base";
import { Name } from "../Name";
import { system } from "../system";
export class Class extends Base {
    base;
    class = "tuple";
    _name;
    get name() {
        return (this._name ??= Name.fromTuple(this.base));
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.map(b => b.definition) });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return (system.Array.isArray(value) &&
            value.length == this.base.length &&
            this.base.every((type, index) => type.is(value[index])));
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: this.base
                .map((type, index) => type.flawed(value?.[index]))
                .map((flaw, index) => (flaw ? { index, ...flaw } : flaw))
                .filter((f) => !!f),
        });
    }
    prune(value) {
        return this.is(value) ? this.base.map((type, index) => type.prune(value[index])) : undefined;
    }
    static create(...base) {
        return new Class(base);
    }
}
//# sourceMappingURL=Class.js.map